import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DeclineModalComponent } from './decline-modal.component';
import { BallotErrorModalModule } from '../ballot/ballot-error-modal.module';
import { ExitModalComponent } from '../exit-modal/exit-modal.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    DeclineModalComponent,
    ExitModalComponent
  ],
  exports: [
    DeclineModalComponent,
  ],
  imports: [
    BallotErrorModalModule,
    CommonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
  ]
})
export class DeclarationModule { }
